<template>
    <header class="header" role="banner">
        <div class="container header__container">
            <div class="header__title">
                <burger-button ref="burger"
                               :is-open="isMenuOpen"
                               class="header__burger"
                               color="#1e428f"
                               @click="onBurgerClicked"
                />

                <a :href="homeUrl"
                   class="header__home-link"
                   role="link"
                >
                    <img src="@/assets/images/intersport-logo.svg"
                         class="header__logo"
                         alt="Intersport"
                         width="200"
                         height="21"
                    />
                    <h1 v-if="currentUrl === homeUrl" class="header__logo-title">Espace presse</h1>
                    <p v-else class="header__logo-title">Espace presse</p>
                </a>
            </div>

            <layout-menu ref="menu"
                         :is-open="isMenuOpen"
                         class="header__menu"
            >
                <slot name="menu"></slot>
            </layout-menu>
        </div>
    </header>
</template>

<script>
    import LayoutMenu from '@/components/layout/Menu';
    import BurgerButton from '@/components/BurgerButton';

    export default {
        name: 'LayoutHeader',

        components: {
            LayoutMenu,
            BurgerButton,
        },

        props: {
            homeUrl:    { type: String, required: true },
            currentUrl: { type: String, required: true },
        },

        data () {
            return {
                isMenuOpen: false,
            };
        },

        methods: {
            onBurgerClicked () {
                this.isMenuOpen = !this.isMenuOpen;
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';
    @import '~@/assets/styles/abstracts/_placeholders';

    .header {
        background: $white;
        position: relative;

        z-index: 2;

        &__container {
            display: flex;
            flex-direction: column;

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }
        }

        &__title {
            display: flex;
            justify-content: center;
            flex: 1 5 100%;

            min-height: 8rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                justify-content: flex-start;
            }
        }

        &__home-link {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &:hover {
                text-decoration: none;
            }

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                flex-direction: row;
            }
        }

        &__logo {
            height: 1.5rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                height: 2rem;
            }
        }

        &__logo-title {
            margin: 0;

            @extend %font-OpenSans-bold;
            text-transform: uppercase;
            font-size: 1.6rem;
            color: $gray-500;

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                padding: 0.4rem 2rem;
                margin-left: 1.8rem;

                border-left: 1px solid $gray-500;

                font-size: 2rem;
            }
        }

        &__burger {
            @include place(0, auto, auto, 0);
            display: flex;

            padding: 1.5rem;

            border: none;
            background: none;

            cursor: pointer;

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                display: none;
            }
        }

        &__menu {
            @include place(8rem, 0, 0, 0, absolute);
            flex: 1 1 100%;

            //noinspection CssOverwrittenProperties
            min-height: 100vh;
            //noinspection CssOverwrittenProperties
            min-height: calc(100vh - 4.8rem);

            z-index: 1;

            @include media-breakpoint-down (md) {
                overflow-y: scroll;
            }

            @include media-breakpoint-up (lg) {
                position: static;
                flex: 0 0 auto;

                min-height: 0;
            }
        }
    }
</style>
